import Journal from './Journal'

export {
  Journal
}


// WEBPACK FOOTER //
// ./src/screens/Journal/index.js